import Vue from "vue";
import VueI18n from "vue-i18n";
import jaMsg from "@/locales/ja";

Vue.use(VueI18n);

const messages = {
  jp: jaMsg,
};

const i18n = new VueI18n({
  locale: "jp", // set locale
  fallbackLocale: "jp", // set fallback locale
  messages, // set locale messages
});

export default i18n;
